// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nightModeModal_modal__VabO9 {
  max-width: 560px;
  max-height: 470px;
  padding: 20px;
  justify-content: flex-start; }
  .nightModeModal_modal__VabO9 .nightModeModal_header__kz4Of {
    font-weight: 600;
    font-size: 32px;
    line-height: 150%;
    letter-spacing: 0.15px;
    color: var(--HightEmphasis);
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative; }
  .nightModeModal_modal__VabO9 .nightModeModal_text__dNCJL {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.15px;
    color: var(--HightEmphasis);
    margin-bottom: 10px; }
  .nightModeModal_modal__VabO9 .nightModeModal_buttons__8HneZ {
    position: absolute;
    bottom: 20px;
    display: flex;
    align-self: flex-end; }
    .nightModeModal_modal__VabO9 .nightModeModal_buttons__8HneZ .nightModeModal_cancel__63ahF {
      background: transparent;
      color: var(--Orange); }
  .nightModeModal_modal__VabO9 button:not(:first-child) {
    margin-left: 20px; }
  .nightModeModal_modal__VabO9 .nightModeModal_inputs__12WmL {
    display: flex;
    min-width: 100%;
    gap: 20px; }
    .nightModeModal_modal__VabO9 .nightModeModal_inputs__left__L\\+zYn {
      width: 50%; }
    .nightModeModal_modal__VabO9 .nightModeModal_inputs__right__1EfVB {
      width: 50%; }
    .nightModeModal_modal__VabO9 .nightModeModal_inputs__12WmL .nightModeModal_input__OqFac {
      margin-top: 6px;
      width: 100%;
      padding: 8px 16px;
      border: 1px solid #9e9e9e;
      border-radius: 4px;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px; }
      .nightModeModal_modal__VabO9 .nightModeModal_inputs__12WmL .nightModeModal_input__OqFac:focus {
        border-color: #212121;
        outline: none; }

.nightModeModal_closeCross__qHwjY {
  font-size: 20px;
  transition: all 0.4s;
  cursor: pointer; }
  .nightModeModal_closeCross__qHwjY:hover {
    transform: scale(1.1); }

.nightModeModal_tooltip__GAIet {
  position: absolute;
  top: 120px;
  left: 128px;
  background: #ffffff;
  box-shadow: 0px 0px 8px rgba(42, 98, 149, 0.25);
  border-radius: 4px;
  padding: 10px;
  z-index: 100; }
  .nightModeModal_tooltip__GAIet h6 {
    font-weight: 600;
    font-size: 12px;
    line-height: 150%;
    color: #666666; }
  .nightModeModal_tooltip__GAIet p {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px; }

.nightModeModal_tooltipSVG__VjxLs {
  fill: #666666;
  cursor: pointer; }
`, "",{"version":3,"sources":["webpack://./src/pages/inventory/components/NightModeModal/nightModeModal.module.scss","webpack://./src/styles/fonts.scss"],"names":[],"mappings":"AAGA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,2BAA2B,EAAA;EAJ7B;ICFE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IDQf,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB,EAAA;EAdtB;ICgBE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IDAf,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB,EAAA;EApBvB;IAwBI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,oBAAoB,EAAA;IA3BxB;MA8BM,uBAAuB;MACvB,oBAAoB,EAAA;EA/B1B;IAoCI,iBAAiB,EAAA;EApCrB;IAuCI,aAAa;IACb,eAAe;IACf,SAAS,EAAA;IAzCb;MA2CM,UAAU,EAAA;IA3ChB;MA8CM,UAAU,EAAA;IA9ChB;MAiDM,eAAe;MACf,WAAW;MACX,iBAAiB;MACjB,yBAAyB;MACzB,kBAAkB;MAClB,gBAAgB;MAChB,eAAe;MACf,iBAAiB,EAAA;MAxDvB;QA0DQ,qBAAqB;QACrB,aAAa,EAAA;;AAMrB;EACE,eAAe;EACf,oBAAoB;EACpB,eAAe,EAAA;EAHjB;IAKI,qBAAqB,EAAA;;AAGzB;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,+CAA+C;EAC/C,kBAAkB;EAClB,aAAa;EACb,YAAY,EAAA;EARd;IAUI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc,EAAA;EAblB;IAgBI,gBAAgB;IAChB,eAAe;IACf,iBAAiB,EAAA;;AAGrB;EACE,aAAa;EACb,eAAe,EAAA","sourcesContent":["@import '../../../../styles/media.scss';\n@import '../../../../styles/fonts.scss';\n\n.modal {\n  max-width: 560px;\n  max-height: 470px;\n  padding: 20px;\n  justify-content: flex-start;\n\n  .header {\n    @include h1;\n    letter-spacing: 0.15px;\n    color: var(--HightEmphasis);\n    margin-bottom: 30px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    position: relative;\n  }\n  .text {\n    @include h4;\n    letter-spacing: 0.15px;\n    color: var(--HightEmphasis);\n    margin-bottom: 10px;\n  }\n\n  .buttons {\n    position: absolute;\n    bottom: 20px;\n    display: flex;\n    align-self: flex-end;\n\n    .cancel {\n      background: transparent;\n      color: var(--Orange);\n    }\n  }\n\n  button:not(:first-child) {\n    margin-left: 20px;\n  }\n  .inputs {\n    display: flex;\n    min-width: 100%;\n    gap: 20px;\n    &__left {\n      width: 50%;\n    }\n    &__right {\n      width: 50%;\n    }\n    .input {\n      margin-top: 6px;\n      width: 100%;\n      padding: 8px 16px;\n      border: 1px solid #9e9e9e;\n      border-radius: 4px;\n      font-weight: 400;\n      font-size: 16px;\n      line-height: 24px;\n      &:focus {\n        border-color: #212121;\n        outline: none;\n      }\n    }\n  }\n}\n\n.closeCross {\n  font-size: 20px;\n  transition: all 0.4s;\n  cursor: pointer;\n  &:hover {\n    transform: scale(1.1);\n  }\n}\n.tooltip {\n  position: absolute;\n  top: 120px;\n  left: 128px;\n  background: #ffffff;\n  box-shadow: 0px 0px 8px rgba(42, 98, 149, 0.25);\n  border-radius: 4px;\n  padding: 10px;\n  z-index: 100;\n  h6 {\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 150%;\n    color: #666666;\n  }\n  p {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 24px;\n  }\n}\n.tooltipSVG {\n  fill: #666666;\n  cursor: pointer;\n}\n","@mixin h1 {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 150%;\n}\n\n@mixin h2 {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 150%;\n}\n\n@mixin h3 {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n}\n\n@mixin h4 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin h5 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin h6 {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin body1 {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin body2 {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n@mixin body3 {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n}\n\n@mixin link1 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin link2 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin caption {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 24px;\n}\n\n@mixin title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin button {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `nightModeModal_modal__VabO9`,
	"header": `nightModeModal_header__kz4Of`,
	"text": `nightModeModal_text__dNCJL`,
	"buttons": `nightModeModal_buttons__8HneZ`,
	"cancel": `nightModeModal_cancel__63ahF`,
	"inputs": `nightModeModal_inputs__12WmL`,
	"inputs__left": `nightModeModal_inputs__left__L+zYn`,
	"inputs__right": `nightModeModal_inputs__right__1EfVB`,
	"input": `nightModeModal_input__OqFac`,
	"closeCross": `nightModeModal_closeCross__qHwjY`,
	"tooltip": `nightModeModal_tooltip__GAIet`,
	"tooltipSVG": `nightModeModal_tooltipSVG__VjxLs`
};
export default ___CSS_LOADER_EXPORT___;
